if (window.matchMedia('(min-width: 1024px)').matches) {
  const activeFacetsDesktopEl = document.querySelector('.active-facets-desktop');
  const facetsClearAllFixedEl = document.querySelector('.active-facets-desktop-fixed');

  let activeFacetsChildrenTotalWidth = 0;
  let isMouseDown = false;
  let startX, scrollLeft;

  const startDragging = (e) => {
    isMouseDown = true;
    startX = e.pageX - activeFacetsDesktopEl.offsetLeft;
    scrollLeft = activeFacetsDesktopEl.scrollLeft;
  };

  const stopDragging = () => {
    isMouseDown = false;
  };

  const handleMove = (e) => {
    e.preventDefault();
    if (!isMouseDown) {
      return;
    }
    const x = e.pageX - activeFacetsDesktopEl.offsetLeft;
    const scroll = x - startX;
    activeFacetsDesktopEl.scrollLeft = scrollLeft - scroll;
  };

  const calcChildrenTotalWidth = (children) => {
    return Array.from(children).reduce((accumulator, currentValue) => {
      return accumulator + currentValue.offsetWidth;
    }, 0);
  };

  const activateDragging = () => {
    activeFacetsDesktopEl.classList.add('draggable');
    facetsClearAllFixedEl.style.display = 'flex';
    activeFacetsDesktopEl.addEventListener('mousemove', handleMove, false);
    activeFacetsDesktopEl.addEventListener('mousedown', startDragging, false);
    activeFacetsDesktopEl.addEventListener('mouseup', stopDragging, false);
    activeFacetsDesktopEl.addEventListener('mouseleave', stopDragging, false);
  };

  const deactivateDragging = () => {
    activeFacetsDesktopEl.classList.remove('draggable');
    facetsClearAllFixedEl.style.display = 'none';
    activeFacetsDesktopEl.removeEventListener('mousemove', handleMove, false);
    activeFacetsDesktopEl.removeEventListener('mousedown', startDragging, false);
    activeFacetsDesktopEl.removeEventListener('mouseup', stopDragging, false);
    activeFacetsDesktopEl.removeEventListener('mouseleave', stopDragging, false);
  };

  const checkActiveFacetsWidth = () => {
    activeFacetsChildrenTotalWidth = calcChildrenTotalWidth(activeFacetsDesktopEl.children);

    if (activeFacetsChildrenTotalWidth > activeFacetsDesktopEl.offsetWidth) {
      activateDragging();
    } else {
      deactivateDragging();
    }
  };

  if (activeFacetsDesktopEl) {
    checkActiveFacetsWidth();

    const mutationCallback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          checkActiveFacetsWidth();
        }
      }
    };

    const observer = new MutationObserver(mutationCallback);

    observer.observe(activeFacetsDesktopEl, { childList: true, subtree: true });
  }
}